// src/firebase.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
// *** ADD THIS LINE ***
import { getFunctions } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY, // This line is now correct and secure
  authDomain: "steps4inclusiveai.firebaseapp.com",
  projectId: "steps4inclusiveai",
  storageBucket: "steps4inclusiveai.firebasestorage.app",
  messagingSenderId: "820912221586",
  appId: "1:820912221586:web:4845425006ca345e7b254b",
  measurementId: "G-MLN28RJCKR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export Firebase services
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
// *** ADD THIS LINE and export it ***
export const functions = getFunctions(app);